import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-06bfe72c"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["size", "href"]
const _hoisted_2 = { class: "inner" }
const _hoisted_3 = ["name", "size"]
const _hoisted_4 = ["size", "href"]
const _hoisted_5 = { class: "inner" }
const _hoisted_6 = ["size"]

import { LinkMetadataSocialMedia } from '@/shared/models/Profile'
import { stripProtocol, truncateMiddle } from '@/shared/utils'
import { InputSize } from './Form/FormTypes'

type Props = {
  link?: LinkMetadataSocialMedia
  size?: InputSize
}


export default /*#__PURE__*/_defineComponent({
  __name: 'LinkButton',
  props: {
    link: { default: undefined },
    size: { default: 'medium' }
  },
  setup(__props: any) {



const getWebReferenceTitle = (url: string, title: string): string =>
  title.length > 0 ? title : stripProtocol(url)

return (_ctx: any,_cache: any) => {
  return (_ctx.link?.socialMediaName)
    ? (_openBlock(), _createElementBlock("lukso-button", {
        key: 0,
        size: _ctx.size,
        href: _ctx.link?.url,
        variant: "text",
        "is-link": "",
        "is-full-width": "",
        "is-icon": "",
        "custom-class": "px-0"
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("lukso-icon", {
            name: `logo-${_ctx.link?.socialMediaName}-mono`,
            size: _ctx.size
          }, null, 8 /* PROPS */, _hoisted_3)
        ])
      ], 8 /* PROPS */, _hoisted_1))
    : (_ctx.link?.url)
      ? (_openBlock(), _createElementBlock("lukso-button", {
          key: 1,
          size: _ctx.size,
          href: _ctx.link.url,
          variant: "secondary",
          "is-link": "",
          "is-full-width": ""
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("lukso-icon", {
              name: "link",
              size: _ctx.size,
              class: "mr-2"
            }, null, 8 /* PROPS */, _hoisted_6),
            _createElementVNode("span", {
              class: _normalizeClass({
          'paragraph-inter-14-medium': _ctx.size === 'medium',
        })
            }, _toDisplayString(_unref(truncateMiddle)(getWebReferenceTitle(_ctx.link.url, _ctx.link?.title), 25, 6)), 3 /* TEXT, CLASS */)
          ])
        ], 8 /* PROPS */, _hoisted_4))
      : _createCommentVNode("v-if", true)
}
}

})